import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import { Skeleton } from "@material-ui/lab";
import { Link, useHistory } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";

import axios from "axios";
import Swal from "sweetalert2";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import Sidebar from "../../components/Sidebar";
import { AuthContext } from "../../context/AuthContext";

const useStyle = makeStyles({
  fieldWrapper: {
    display: "flex",
    marginBottom: 30,
  },
  input: {
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  margin: {
    marginBottom: 20,
  },
  marginTop: {
    marginTop: 20,
  },
  subtitleStyle2: {
    paddingBottom: 3,
    borderBottom: "1px solid #ddd",
  },
  buttonStyle: {
    padding: " 10px 30px",
    fontSize: 14,
    borderRadius: "25px",
    marginLeft: 20,
  },
  buttonWeraper2: {
    marginTop: 25,
    float: "right",
  },
  buttonWeraper: {
    float: "right",
    marginTop: "-4px",
    height: 0,
    position: "relative",
  },
  subtitleStyle: {
    fontSize: "1.22rem",
    marginBottom: 7,
  },
  checkBoxList: {
    marginLeft: 20,
    color: "#666",
  },
  headline: {
    margin: "30px 0 0 30px",
  },
  padding30: {
    padding: 30,
  },
  listHeader: {
    color: "#333",
  },
});

const CreateRole = () => {
  const classes = useStyle();
  const history = useHistory();
  const location = useLocation();
  const roleId = location.state;
  const { auth, logout } = useContext(AuthContext);
  const [role_name, set_role_name] = useState("");
  const [myList, setMylist] = useState([]);
  const [roles, set_roles] = useState([]);
  const [role_id, set_role_id] = useState(0);

  const [refresh, setRefresh] = useState(false);
  const [refresh2, setRefresh2] = useState(false);
  const [loading, setLoading] = useState(false);

  const getRoles = async () => {
    try {
      let url = `/api/roles`;
      let res = await axios({
        url: url,
        method: "get",
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      let listData = res.data.data;
      set_roles(listData);

      if (roleId) {
        let roleName = res.data.data.filter((item) => item.id === roleId);
        set_role_name(roleName[0].name);
      }
    } catch (error) {
      if (error.response.status == 401) {
        logout();
      }
      Swal.fire({
        icon: "warning",
        title: `${error.response.data.messages.toString()}`,
        showConfirmButton: false,
        // timer: 2000,
      });
    }
  };

  const getPermissions = async (my_id) => {
    setLoading(true);
    try {
      let url = `/api/module-permissions`;
      let res = await axios({
        url: url,
        method: "get",
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      let listData = res.data.data;
      myArray(listData, my_id);
      setRefresh(!refresh);
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: `${error.response.data.messages.toString()}`,
        showConfirmButton: false,
        // timer: 2000,
      });
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let list = formatMyList();
    // console.log("permission", list);
    try {
      let res = await axios({
        url: `/api/role/${role_id}`,
        method: "post",
        data: {
          permissions: list,
        },
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      if (res.data.code === 200) {
        Swal.fire({
          icon: "success",
          title: "Succesfully Updated",
          showConfirmButton: false,
          timer: 1000,
        });
        set_role_name("");
        history.push("/view-role");
      } else {
        Swal.fire({
          icon: "warning",
          title: "Something is wrong",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: `${error.response.data.messages.toString()}`,
        showConfirmButton: false,
        timer: 2000,
      });
    }
    setLoading(false);
  };

  const myArray = async (allData, my_id) => {
    let url = `/api/role/${my_id}`;
    axios({
      url: url,
      method: "get",
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
      .then((res) => {
        let assigned_permissions = res.data.data.assigned_permissions;

        let list = [];
        Object.keys(allData).map((parent) => {
          let inner = [];
          allData[parent].map((child) => {
            let selected = assigned_permissions.includes(child.permission);

            inner.push({
              function_name: child.function_name,
              permission: child.permission,
              select: selected,
              module_name: child.module_name,
              id: child.id,
            });
          });
          list.push({ parent: parent, child: inner });
          setMylist(list);
          setRefresh(!refresh);
        });
      })
      .then((res) => {
        setRefresh2(!refresh2);
      });
  };

  const handleCheckList = (checked, name, parent) => {
    let mylist2 = [];
    myList.forEach((e) => {
      if (e.parent === parent) {
        e.child.map((item) => {
          if (item.function_name === name) {
            item.select = checked;
          }
          return item;
        });
      }
      mylist2.push(e);
    });
    setMylist(mylist2);
  };

  const handleCheckListHeader = (checked, parent) => {
    let mylist2 = [];
    myList.forEach((e) => {
      if (e.parent === parent) {
        e.child.map((item) => {
          item.select = checked;
          return item;
        });
      }
      mylist2.push(e);
    });
    setMylist(mylist2);
  };

  const formatMyList = () => {
    let formatList = [];
    myList.forEach((e) => {
      e.child.map((item) => {
        if (item.select) {
          return formatList.push(item.permission);
        }
      });
    });
    return formatList;
  };

  const handleChangeRole = (e) => {
    set_role_id(e.target.value);
    getPermissions(e.target.value);

    let roleName = roles.filter((item) => item.id === e.target.value);
    set_role_name(roleName[0].name);
  };

  useEffect(() => {
    getPermissions(role_id);
    getRoles();
    if (roleId) {
      set_role_id(roleId);
      getPermissions(roleId);
    }
  }, []);

  return (
    <div>
      <div className="wrapper">
        <Sidebar />
        <div className="wrapper-inner">
          <div className={classes.buttonWeraper}>
            {/* <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.buttonStyle}
            >
              <Link to="/create-role">Create Role</Link>
            </Button> */}
          </div>
          <Typography variant="h4" className={classes.margin}>
            View Role
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              <Grid md={12} item>
                <div>
                  <Card>
                    <CardContent className={classes.padding30}>
                      <Typography
                        variant="subtitle1"
                        className={classes.subtitleStyle}
                      >
                        Select role to view details
                      </Typography>
                      <div>
                        <TextField
                          id="outlined-select-currency"
                          select
                          // value={currency}
                          onChange={handleChangeRole}
                          // value={forward_to_id}
                          // onChange={(e) => set_forward_to_id(e.target.value)}
                          variant="outlined"
                          fullWidth
                          required
                          value={role_id}
                          InputProps={{
                            className: classes.select,
                          }}
                        >
                          {roles.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <Typography
                        variant="subtitle1"
                        className={
                          classes.subtitleStyle +
                          " " +
                          classes.marginTop +
                          " " +
                          classes.subtitleStyle2
                        }
                      >
                        {role_name ? <>{role_name} have access to</> : null}
                      </Typography>
                      <Grid container>
                        {loading ? (
                          <>
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                            <Skeleton
                              width="100%"
                              animation="wave"
                              height="50px"
                            />
                          </>
                        ) : (
                          myList.map((list, index) => (
                            <Grid item md={4} key={index}>
                              <FormControlLabel
                                className={classes.listHeader}
                                control={
                                  <Checkbox
                                    onChange={(e) => {
                                      handleCheckListHeader(
                                        e.target.checked,
                                        e.target.name
                                      );
                                    }}
                                    color="primary"
                                    name={list.parent}
                                    value={list.parent}
                                  />
                                }
                                label={
                                  <span style={{ fontSize: "1.15rem" }}>
                                    <strong>{list.parent}</strong>
                                  </span>
                                }
                              />
                              <br />
                              {list.child.map((child, index2) => (
                                <div key={index2}>
                                  <FormControlLabel
                                    className={classes.checkBoxList}
                                    control={
                                      <Checkbox
                                        onChange={(e) =>
                                          handleCheckList(
                                            e.target.checked,
                                            e.target.name,
                                            list.parent
                                          )
                                        }
                                        color="primary"
                                        name={child.function_name}
                                        value={child.permission}
                                        checked={child.select}
                                      />
                                    }
                                    label={
                                      <span style={{ fontSize: "1.0rem" }}>
                                        {child.function_name}
                                      </span>
                                    }
                                  />
                                  <br />
                                </div>
                              ))}
                            </Grid>
                          ))
                        )}
                      </Grid>
                    </CardContent>
                  </Card>
                  {loading ? (
                    <LinearProgress style={{ marginTop: 20 }} />
                  ) : (
                    <div className={classes.buttonWeraper2}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.buttonStyle}
                        type="submit"
                      >
                        Update Role
                      </Button>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateRole;
